import { Component } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseComponent } from '../base-component';
import { Error } from '../exception';
import { appInjector } from '../app-injector';
import { ExceptionHttp } from '../exception-http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent extends BaseComponent {
  message: string;
  constructor(public modalRef: BsModalRef) {
    super();
  }

  static show(error: string | Error) {
    // const exceptionHTTP = error as ExceptionHttp;
    // if (exceptionHTTP && exceptionHTTP.status === 503) {
    //   const router: Router = appInjector.get(Router);

    // }

    console.error(error);
    const modalService = appInjector.get(BsModalService);

    modalService.show(ErrorModalComponent, {
      initialState: {
        message: typeof error == 'string' ? error : error.message
      }
    });
  }
}
